// extracted by mini-css-extract-plugin
export default {"container":"Gallery_container__i0Khf","header":"Gallery_header__sXg4O","content":"Gallery_content__IYpjh"};